// var ProgressBar = require('progressbar.js');
// var line = new ProgressBar.Line('#container');
var scroll = require('./_scroll');
var objectFit = require('object-fit');
    // frontpage_logos = require('./_frontpagelogos');

!(function(window,document,$,undefined) {
    'use strict';
    $(document).ready(function() {
        scroll.init($);
        // frontpage_logos.init($);
        objectFit.polyfill({
        selector: '.video-background', // this can be any CSS selector
        fittype: 'cover', // either contain, cover, fill or none
        disableCrossDomain: 'false' // either 'true' or 'false' to not parse external CSS files.
        });
        $(window).on('scroll', function() {
            $('.p_fx').each( function(index) {
                var $this = $(this);
                var bg_center_p = (  $(document).scrollTop() - $this.offset().top ) / $(window).height();
                bg_center_p = bg_center_p >= 1 ? 1 : bg_center_p;
                bg_center_p = bg_center_p <= 0 ? 0 : bg_center_p;
                // console.log( 'scrolltop:'+$(document).scrollTop());
                // console.log( 'offset_top:' + $this.offset().top);
                // console.log( bg_center_p + ': ' + ( ( bg_center_p * 50 ) + 50 ) );
                $this.css('background-position-y', ( ( bg_center_p * 50 ) + 50 ) + '%');
            });
        });
        $('.menu_btn, .show_menu').on('click',function(e) {
            e.preventDefault();
            var $this = $(this);
            $('body').toggleClass('menu_toggled');
            if( $this.hasClass('open_contact') ) {
                var top = $("#inqury_container").position().top - 140;
                console.log(top);
                $("#primary-menu-container").scrollTop( top );
            } else {
                $("#primary-menu-container").scrollTop( 0 );
            }
        });

        /**
         * Services
         * <li> column 
         */
        $('.services_item_text_inside ul').each( function() {
            var $this = $(this);
            if( $this.find('li').length > 4 ) {
                $this.addClass('col_2');
            }
        });
        /**
         * Work Filter
         */
        var setEven_works = function() {
            $('.our_work_item').removeClass('pushdown');
            $('.visible:odd').addClass('pushdown');
        }
        setEven_works();
        $('.our_works_filter_btn').on('click',function(e) {
            e.preventDefault();
            var $this = $(this);
            $('.our_works_list').fadeOut().promise().done(function() {
                $('.our_work_item').removeClass('visible').hide();
                if( $this.data('filter') == 'all') {
                    $('.our_work_item').addClass('visible').show();
                } else {
                    $( '.'+$this.data('filter') + '.our_work_item' ).addClass('visible').show().promise();
                }
                setEven_works();
                $('.our_works_list').fadeIn().promise();
            });
        });
        /**
         * Show This Video
         */
        $('.show_video').on('click',function(e) {
            e.preventDefault();
            var $this = $(this);
            $('#video_container').fadeIn().promise().done( function() {
                $('#video_container iframe').attr({'src': 'https://player.vimeo.com/video/'+$this.data('videoid')+'?autoplay=1&color=eeeeff&title=0&byline=0&portrait=0)'});
            });
        });
        
        $('.close_video_container').on('click',function(e) {
            e.preventDefault();
            $('#video_container').fadeOut().promise().done(function() {
                $('#video_container iframe').attr({'src': ''});
            });;
        });
        /**
         * Show This Video
         */
        $('.show_single').on('click',function(e) {
            e.preventDefault();
            var $this = $(this);
            var $selected_item = $( '#work_' + $this.data('textid') );
            // console.log($selected_item);
            $('#text_container').fadeIn().promise().done( function() {
                $('#text_container .text_container_img').css({'background-image' : 'url('+$selected_item.data('bgsrc')+')'});
                $('#text_container .text_container_length').html( $selected_item.data('length') );
                $('#text_container .text_container_text').html( $selected_item.find('.our_work_text').html() );
                $('#text_container .show_video').attr('data-videoid',$selected_item.data('videoid') );
                $('#text_container').addClass('visible');
            });
        });
        
        $('.close_text_container').on('click',function(e) {
            e.preventDefault();
            $('#text_container').fadeOut().promise().done(function() {
                $('#text_container').removeClass('visible');
                $('#text_container .text_container_img').css({'background-image':'url()'});
                $('#text_container .text_container_length').html( '00:00' );
                $('#text_container .text_container_text').html('');
                $('#text_container .show_video').attr('data-videoid','' );

            });;
        });
    });

    // Window on load - remove the loading overlay
    $(window).on('load', function() {
        $('body').addClass('loaded');
        setTimeout( function() {
            $('#loading').addClass('run');
        }, 1000 );
        $('#loading #loading_lines').animate({
            'width': '26.6rem'
        }, 1000, function() {
            setTimeout( function() {
                $('#loading').fadeOut(1000).promise();
            }, 500 );
        });
    });

})(window,document,jQuery);
